/* eslint-disable */
import { META_GENDERS } from "../../../../modules/SocialMedia/SocialMediaConstant";
import { CONTENT_DISTRIBUTION_API, DAYS, OPERATING_SYSTEM, PLATFORM, PRODUCTS } from "../../../constant/constant";

export const PlatformCell = (props) => {
  const field = props?.field ?? "";
  const value = props?.dataItem?.[field];

  let displayValue = '';

  if (typeof value === 'string' && value.trim()) {
    const valueArray = value.split(',').map(v => v.trim()).filter(Boolean);

    displayValue = valueArray.map((val) => PLATFORM.find(x => x.SID == val)?.Description || "").filter(Boolean).join(', ');
  }

  return <td>{displayValue ?? ''}</td>;
};

export const stringEnumCell = (props, enumValue, display = "Description") => {
  const field = props?.field ?? "";
  const value = props?.dataItem?.[field];

  let displayValue = '';

  if (typeof value === 'string' && value.trim()) {
    const valueArray = value.split(',').map(v => v.trim()).filter(Boolean);

    displayValue = valueArray.map((val) => {
        const match = enumValue.find(x => (x.SID ?? x.ID) == val);
        return match?.[display] || '';
      }).filter(Boolean).join(', ');
  }

  return <td>{displayValue ?? ''}</td>;
};

export const arrayEnumCell = (props) => {

  const field = props?.field;
  const value = props?.dataItem?.[field];

  const foreignKeyMap = {
    Products: PRODUCTS,
    genders: META_GENDERS,
    OS: OPERATING_SYSTEM,
    ContentDistributionApiIds: CONTENT_DISTRIBUTION_API
  };
  
  let displayValue = '';

  if (Array.isArray(value) && value.length > 0 && foreignKeyMap[field]) {
    const matchedKeys = Object.entries(foreignKeyMap[field]).filter(([_, val]) => value.includes(val)).map(([key]) => key);

    displayValue = matchedKeys.join(', ');
  }

  return <td>{displayValue ?? ''}</td>;
};

export const daysCell = (props) => {
  const field = props?.field ?? "";
  const value = props?.dataItem?.[field];

  let displayValue = '';

  if (Array.isArray(value) && value.length > 0) {
    displayValue = DAYS.filter(obj => value.includes(obj?.ID)).map(obj => obj?.Name).filter(Boolean).join(', ');
  }

  return <td>{displayValue ?? ''}</td>;
};
